module.exports = __webpack_public_path__ + "static/media/13.ad91d7af.png";